<template>
  <v-treeview 
    :items="itemsTree" 
    item-key="id"
    item-text="text"
    open-all>
    <template v-slot:label="{ item, open }">
      <v-btn
        class="p-0 m-0"
        text
        @click="onSelect(item)"
        :class="
          selected &&
          item.object[id] === selected[id] &&
          'blue--text'
        "
      >
        <v-icon class="mr-2" color="blue-grey darken-2">
          {{ open && hasChildren(item) ? "mdi-folder-open" : "mdi-folder" }}
        </v-icon>
        {{ item['text'] }}
      </v-btn>
    </template>
  </v-treeview>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default : () => []
    },
    id: {
      type: String,
      default: "uuid"
    },
    text: {
      type: String,
      default: "name"
    },
    parent: {
      type: String,
      default: "parent"
    }
  },
  data: () => ({
    selected : undefined
  }),
  computed: {
    itemsTree() {
      const tree = {};
      const id = this.id;
      this.items.forEach(acc => {
        tree[acc[id]] = {
          id : acc[id],
          text: acc[this.text],
          children : [],
          object : acc,
        }
      });
      const roots = [];
      Object.values(tree).forEach(acc => {
        if (acc.object[this.parent]) {
          const parentKey = acc.object[this.parent][id];
          tree[parentKey].children.push(acc);
        } else {
          roots.push(acc);
        }
      });
      return roots;
    },
  },
  methods: {
    onSelect(item) {
      this.$emit("onClick", item.object);
    },
    hasChildren(item) {
      return item.children.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>